import React, { useState } from 'react'
import { ChampDansFormulaire } from './types/typePourChampDansFormulaireModel'
import { InputAdornment } from '@mui/material'
import frLocale from 'date-fns/locale/fr'
import { useFormContext } from 'react-hook-form'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import CustomTextField from './CustomTextField'
import { fontFamilyMonserrat, gecinaBlueMain } from '../../theme'
import SvgCalendar from '../../icons/SvgCalendar'
import { filtresListeProceduresFieldsEnum } from '../../modules/listeProcedures/enums/listeProceduresEnum'
import { creationProceduresFieldsEnum } from '../../modules/creationProcedure/enums/creationProcedureEnum'

interface AcceptingProps {
	id: string,
	label?: string,
	inputTextStyle?: string,
	selectFuture?: boolean,
	hasDefault?: boolean,
	manual?: boolean,
	setMinDate?: string,
	readonly?: boolean,
	minDate?: boolean,
	errorWhite?: boolean
}

type FormDatePickerFieldProps =
	ChampDansFormulaire
	& AcceptingProps

const FormDatePickerField: React.FC<FormDatePickerFieldProps> = (
	{
		register,
		label,
		minDate = false,
		errorWhite = false
	}
) => {
	const { formState: { errors }, setError, clearErrors, getValues, setValue } = useFormContext()

	const [open, setOpen] = useState<boolean>(false)

	const limiteurDateMin = () => {
		if (minDate) {
			return new Date()
		}
		return undefined
	}

	return (
		<>
			{
				label && (
					<span
						style={{
							width: '100%',
							paddingRight: 15,
							paddingTop: 7,
							fontSize: 14,
							marginBottom: 5,
							marginLeft: 0,
							boxSizing: 'border-box',
							textAlign: 'left',
							fontFamily: fontFamilyMonserrat,
							fontWeight: 500
						}}
					>
						{label}
					</span>
				)
			}

			<LocalizationProvider
				dateAdapter={AdapterDateFns}
				locale={frLocale}
			>
				<DatePicker
					renderInput={(props) => (
						<CustomTextField
							{...props}
							register={register}
							id={`${register.name}-datepicker`}
							errorWhite={errorWhite}
							fromDatePicker
							InputProps={{
								...props.InputProps,
								startAdornment: (
									<InputAdornment
										position="start"
										onClick={() => setOpen(true)}
									>
										<SvgCalendar color={gecinaBlueMain} style={{ cursor: 'pointer' }} />
									</InputAdornment>
								)
							}}
						/>
					)}
					mask="__/__/____"
					inputFormat="dd/MM/yyyy"
					minDate={limiteurDateMin()}
					value={getValues(register.name)}
					onChange={(newValue) => {
						clearErrors(register.name)
						const rightDate = newValue && newValue.getTime() + 7200000
						const datePlusUTC = rightDate && new Date(rightDate)
						const finalValue = new Date(datePlusUTC ?? '')
						if (isNaN(finalValue.valueOf()) || minDate && finalValue < new Date()) {
							setError(register.name, { type: 'custom', message: 'Date invalide' })
						}
						if (datePlusUTC) {
							setValue(register.name, datePlusUTC ?? undefined)
						}
					}}
					open={open}
					onClose={() => {
						setOpen(false)
					}}
				/>
			</LocalizationProvider>
		</>
	)
}

export default FormDatePickerField
